import { render, staticRenderFns } from "./newCustomer.vue?vue&type=template&id=15b09a2f&scoped=true"
import script from "./newCustomer.vue?vue&type=script&lang=js"
export * from "./newCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b09a2f",
  null
  
)

export default component.exports